import Icon from './components/Icon';
import Svg from './svg/session-canceled.svg';
export default props => <Icon component={Svg} data-name="CanceledIcon" {...props} />;